export default "__VITE_ASSET__CBDI0RaM__"